export const MAX_FILES_PER_MESSAGE = 10

const UNITS = ['B', 'KB', 'MB', 'GB']

export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || bytes < 0) return ''
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024
    unit += 1
  }

  return `${unit === 0 || value >= 10 ? Math.round(value) : value.toFixed(1)} ${UNITS[unit]}`
}

/** Failure codes the server reports for rejected or unprocessable files. */
const KNOWN_FILE_FAILURES = [
  'malware_detected',
  'invalid_image',
  'scanner_unavailable',
  'WORKSPACE_READ_ONLY',
  'upload_abandoned',
  'upload_intent_failed',
] as const

export function fileFailureKey(code: string | null | undefined): string {
  return (KNOWN_FILE_FAILURES as ReadonlyArray<string>).includes(code ?? '')
    ? `aiChat:files.failures.${code}`
    : 'aiChat:files.failures.generic'
}
